import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import { useSelector } from 'react-redux';

export default function PatientHistoryInfo() {
  // Sample data
  const investigationOfFemalePartnerData = useSelector(
    (state) => state.clinicalReducer.investigationOfFemalePartner,
  );

  const examinationOfMalePartner = useSelector(
    (state) => state.clinicalReducer.examinationOfMalePartner,
  );

  const treatmentPlanForm = useSelector(
    (state) => state.clinicalReducer.currentCycle.fmsData.treatmentPlanForm,
  );
  const historyData = {
    patientInfo: {
      husband: {
        bloodGroup: examinationOfMalePartner.BldGrp,
        hiv: examinationOfMalePartner.HIV,
        hepB: examinationOfMalePartner.Hb,
        hcv: examinationOfMalePartner.HIV,
        vdrl: examinationOfMalePartner.HIV,
      },
      wife: {
        bloodGroup: investigationOfFemalePartnerData.partnerBloodGroup,
        hiv: investigationOfFemalePartnerData.partnerHIV,
        hepB: investigationOfFemalePartnerData.partnerHB,
        hcv: investigationOfFemalePartnerData.partnerHCV,
        vdrl: investigationOfFemalePartnerData.partnerVDRL,
      },
      d2Hormone: {
        amh: treatmentPlanForm.amh,
        fsh: investigationOfFemalePartnerData.partnerFSH,
        lh: investigationOfFemalePartnerData.partnerLH,
        e2: investigationOfFemalePartnerData.partnerE2,
      },
      afc: {
        lo: investigationOfFemalePartnerData.partnerLeftOvary,
        ro: investigationOfFemalePartnerData.partnerRightOvary,
      },
    },
  };

  return (
    <div className="theme-blush">
      <div className="container-fluid">
        <Card sx={{ width: '100%', padding: 2 }}>
          <CardContent>
            {/* Table for Husband, Wife, D2 Hormone */}
            <Typography variant="body1" gutterBottom>
              <span style={{ fontWeight: 'bold' }}>Medical Test Results:</span>
            </Typography>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell style={{fontWeight:700}}> </TableCell>
                    <TableCell style={{fontWeight:700}}>Blood Group</TableCell>
                    <TableCell style={{fontWeight:700}}>HIV</TableCell>
                    <TableCell style={{fontWeight:700}}>HEP. B</TableCell>
                    <TableCell style={{fontWeight:700}}>HCV</TableCell>
                    <TableCell style={{fontWeight:700}}>VDRL</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell style={{fontWeight: 700}}>MALE</TableCell>
                    <TableCell>
                      {historyData.patientInfo.husband.bloodGroup}
                    </TableCell>
                    <TableCell>{historyData.patientInfo.husband.hiv}</TableCell>
                    <TableCell>
                      {historyData.patientInfo.husband.hepB}
                    </TableCell>
                    <TableCell>{historyData.patientInfo.husband.hcv}</TableCell>
                    <TableCell>
                      {historyData.patientInfo.husband.vdrl}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{fontWeight: 700}}>FEMALE</TableCell>
                    <TableCell>
                      {historyData.patientInfo.wife.bloodGroup}
                    </TableCell>
                    <TableCell>{historyData.patientInfo.wife.hiv}</TableCell>
                    <TableCell>{historyData.patientInfo.wife.hepB}</TableCell>
                    <TableCell>{historyData.patientInfo.wife.hcv}</TableCell>
                    <TableCell>{historyData.patientInfo.wife.vdrl}</TableCell>
                  </TableRow>

                  {/* Row for L.O and R.O under HCV and VDRL */}
                  {/* <TableRow>
                    <TableCell align="right">L.O:</TableCell>
                    <TableCell colSpan={3} />
                    <TableCell align="right">{historyData.patientInfo.husband.hcv === 'Positive' ? 'Positive' : 'Negative'}</TableCell>
                    <TableCell align="right">R.O:</TableCell>
                    <TableCell align="right">{historyData.patientInfo.husband.vdrl === 'Positive' ? 'Positive' : 'Negative'}</TableCell>
                  </TableRow> */}
                </TableBody>
              </Table>
            </TableContainer>

            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell style={{fontWeight: 700}}> </TableCell>
                    <TableCell style={{fontWeight: 700}}> </TableCell>
                    <TableCell style={{fontWeight: 700}}>AMH</TableCell>
                    <TableCell style={{fontWeight: 700}}>FSH</TableCell>
                    <TableCell style={{fontWeight: 700}}>LH</TableCell>
                    <TableCell style={{fontWeight: 700}}>E2</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell style={{fontWeight: 700}}>D2 Hormone (W)</TableCell>
                    <TableCell style={{fontWeight: 700}}> </TableCell>
                    <TableCell>
                      {historyData.patientInfo.d2Hormone.amh}
                    </TableCell>
                    <TableCell>
                      {historyData.patientInfo.d2Hormone.fsh}
                    </TableCell>
                    <TableCell>
                      {historyData.patientInfo.d2Hormone.lh}
                    </TableCell>
                    <TableCell>
                      {historyData.patientInfo.d2Hormone.e2}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>

            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell style={{fontWeight: 700}}>L.O.</TableCell>
                    <TableCell style={{fontWeight: 700}}>R.O.</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell style={{fontWeight: 700}} >Antral Follicle Count</TableCell>
                    <TableCell>{historyData.patientInfo.afc.lo}</TableCell>
                    <TableCell>{historyData.patientInfo.afc.ro}</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
